import { Navigate, useLocation } from 'react-router';
import { EmployerFacilitiesPage } from '~/features/market/facility';
import { paths } from './routes';

/**
 * Canonicalizes the hashes used by the former Organization tabs. The old
 * Employer Info tab now has its own route, while Facilities remains here.
 */
export const EmployerFacilitiesRoute = () => {
  const location = useLocation();

  if (location.hash) {
    const pathname =
      location.hash === '#employer-info' ? paths.hlx.employerInfo : paths.hlx.facilities;

    return <Navigate replace to={{ pathname, search: location.search }} />;
  }

  return <EmployerFacilitiesPage />;
};
